export default __webpack_public_path__ + "static/tira_taller_movil_nissan-c4a7b435ecc8eefe06844913fada862c.png";